import { render, staticRenderFns } from "./ShieldLock.vue?vue&type=template&id=2e055078"
import script from "./ShieldLock.vue?vue&type=script&lang=js"
export * from "./ShieldLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports